/**
 * Рецепты комбинаций - данные из alchemy_tree (6).html
 * 56 рецептов
 */

import { Recipe } from '../types/game';

export const RECIPES: Recipe[] = [
    // Уровень 2
    [["fire", "water"], "steam"],          // пар от огня и воды
    [["fire", "earth"], "lava"],           // расплавленная земля
    [["water", "earth"], "mud"],           // мокрая земля
    [["earth", "air"], "dust"],            // ветер поднимает пыль
    [["air", "fire"], "energy"],           // горение = энергия
    [["earth", "earth"], "stone"],         // сжатая земля
    [["air", "air"], "wind"],              // движение воздуха
    [["fire", "mud"], "coal"],             // высушенная органика → торф → уголь

    // Уровень 3
    [["steam", "air"], "cloud"],           // пар поднимается в небо
    [["steam", "dust"], "cloud"],          // пар с частицами
    [["lava", "water"], "obsidian"],       // охлаждённая лава
    [["stone", "wind"], "sand"],           // эрозия камня
    [["dust", "wind"], "sand"],            // накопление пыли
    [["stone", "lava"], "metal"],          // выплавка из руды
    [["coal", "lava"], "metal"],           // уголь как топливо для плавки
    [["energy", "air"], "lightning"],      // электричество в воздухе
    [["water", "wind"], "ice"],            // холодный ветер замораживает
    [["water", "dust"], "ice"],            // пыль как ядро кристаллизации
    [["mud", "steam"], "plant"],           // тёплая влажная почва
    [["coal", "mud"], "plant"],            // удобренная почва (органика)
    [["stone", "water"], "crystal"],       // минералы кристаллизуются
    [["coal", "stone"], "crystal"],        // уголь под давлением = алмаз

    // Уровень 4
    [["energy", "lava"], "sun"],           // энергия + жар = солнце
    [["energy", "obsidian"], "sun"],       // энергия из тёмного = свет
    [["crystal", "cloud"], "moon"],        // светящийся кристалл в небе
    [["ice", "cloud"], "moon"],            // холодное небесное тело
    [["plant", "energy"], "tree"],         // энергия роста
    [["plant", "mud"], "tree"],            // растение в почве
    [["sand", "lightning"], "glass"],      // молния плавит песок
    [["sand", "fire"], "glass"],           // огонь плавит песок
    [["cloud", "lightning"], "storm"],     // гроза
    [["wind", "lightning"], "storm"],      // буря
    [["metal", "obsidian"], "sword"],      // твёрдые материалы
    [["metal", "fire"], "sword"],          // ковка меча

    // Уровень 5 (по 2 рецепта)
    [["metal", "sun"], "gold"],            // солнечный металл (алхимия)
    [["glass", "sun"], "gold"],            // трансмутация через свет
    [["tree", "storm"], "life"],           // жизнь выживает в буре
    [["tree", "ice"], "life"],             // жизнь пробуждается после зимы
    [["crystal", "moon"], "magic"],        // лунная мистика
    [["sword", "storm"], "magic"],         // магический меч

    // Уровень 6: Философский Камень (любые 2 легендарных)
    [["gold", "life"], "philosopher_stone"],
    [["gold", "magic"], "philosopher_stone"],
    [["life", "magic"], "philosopher_stone"],
];
// Вспомогательные функции для работы с рецептами

/**
 * Найти рецепт по двум ингредиентам
 * Порядок ингредиентов не имеет значения
 */
export function findRecipe(element1: string, element2: string): string | null {
  for (const recipe of RECIPES) {
    const [inputs, output] = recipe;
    const [input1, input2] = inputs;

    // Проверяем оба порядка
    if ((input1 === element1 && input2 === element2) ||
        (input1 === element2 && input2 === element1)) {
      return output;
    }
  }
  return null;
}

/**
 * Получить все рецепты, которые создают заданный элемент
 */
export function getRecipesFor(elementKey: string): Recipe[] {
  return RECIPES.filter(([_, output]) => output === elementKey);
}

/**
 * Получить все элементы, которые можно создать из заданного
 */
export function getOutputsFor(elementKey: string): string[] {
  const outputs = new Set<string>();
  for (const [inputs, output] of RECIPES) {
    if (inputs.includes(elementKey)) {
      outputs.add(output);
    }
  }
  return Array.from(outputs);
}

/**
 * Проверить, можно ли комбинировать два элемента
 */
export function canCombineElements(element1: string, element2: string): boolean {
  return findRecipe(element1, element2) !== null;
}
